<template>
  <app-popup title="Импорт приборов учета" :active.sync="isActive">
    <upload-devices @uploaded="openAnswer"/>
    <devices-import-popup
            title="Импорт устройств завершен"
            :isOpen.sync="isAnswerActive"
            :info="answerInfo"
    />
  </app-popup>
</template>

<script>
  import UploadDevices from "@/components/calculated-program/import/UploadDevices";
  import DevicesImportPopup from "@/components/calculated-program/import/DevicesImportPopup";

  export default {
    name: "MeteringDeviceImportPopup",
    components: {
      UploadDevices,
      DevicesImportPopup
    },
    data() {
      return {
        isActive: false,
        isAnswerActive: false,
        answerInfo: {}
      }
    },
    methods: {
      open() {
        this.isActive = true;
      },
      close() {
        this.closeAnswer();
        this.isActive = false;
      },
      openAnswer(data) {
        this.isAnswerActive = true;
        this.answerInfo = data.info;
      },
      closeAnswer() {
        this.isAnswerActive = false;
      }
    }
  }
</script>

<style scoped>

</style>
